import { useTitleChange } from '@msaf/core-react'
import LithologyWrapper from '../../../../components/well-forms/lithology/lithology-wrapper'

export default function ViewWellLithology() {
  useTitleChange('View Well | Lithology')

  return <LithologyWrapper />
}
